import Price from './Price';
import { withModel } from '../../data-providers/model';

export default withModel(Price);



// WEBPACK FOOTER //
// ./src/client/js/view/components/Price/index.js